export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9871_IMPROVEMENT_HISTORY': 'Improvement History',
    '_9872_SCORECARD_HISTORY': 'Scorecard History',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_9853_IMPROVEMENT_CATEGORY': 'Improvement Category',
    '_9873_MI2_PERIOD_': 'MI2 Period:',
    '_9857_SCORECARD_CATEGORY': 'Scorecard Category',
    '_9875_SCORECARD_DATE_': 'Scorecard Date:',
    '_9877_SCORECARD_SCORE_': 'Scorecard Score:',
    '_804_SUPERGROUP_': 'SuperGroup:',
    '_11045_PERIOD_DATE:': 'Period Date',
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_768___TO_TARGET': '% to Target',
    '_4105_PREVIOUS_ACTUAL': 'Previous Actual'
};
